<div id="banner">
</div>
<div style="display: flex; flex-wrap: wrap; height: 100%">
  <div style="width: 50%" class="sky-bg">
    <div id="content"></div>
  </div>

  <div
    style="
      width: 50%;
      align-items: center;
      justify-content: center;
      display: flex;
    "
  >
    <div style="flex-direction: column">
      <div class="text-center">
        <div class="logo logo-desktop hidden lg:block">
          <ng-container *ngIf="logoHyperlink">
            <a [href]="logoHyperlink" target="_blank">
              <img
                [src]="desktopLogoUrl"
                class="mx-auto"
                style="max-width: 233px"
              />
            </a>
          </ng-container>
          <ng-container>
            <img
              [src]="desktopLogoUrl"
              class="mx-auto"
              style="max-width: 233px"
            />
          </ng-container>
        </div>
      </div>
      <div class="text-center">
        <div id="LoginControl" class="form">
          <form style="text-align: start" (keydown)="clearExistingFormErrors()">
            <fieldset>
              <input
                matInput
                class="input-field"
                placeholder="Username"
                id="username"
                #userName
              />
              <div class="text-danger">{{ userNameError }}</div>
            </fieldset>
            <fieldset>
              <input
                matInput
                name="password"
                placeholder="Password"
                id="password"
                #password
                type="password"
              />
              <div class="text-danger">{{ passwordError }}</div>
            </fieldset>
            <ng-container
              *ngTemplateOutlet="
                submitButton;
                context: {
                  label: 'Login.Login',
                  isBusyLabel: 'Login.LoggingIn',
                  isBusy: isLoggingIn,
                  onClick: onLoginClick.bind(this),
                  data: { userName: userName?.value, password: password?.value }
                }
              "
            ></ng-container>
          </form>
        </div>
        <div class="flex items-center justify-center">
          <a (click)="onForgotPasswordClick($event)" style="cursor: pointer">
            {{ 'Login.ForgotPassword' | translate }}</a
          >
        </div>
        <div class="flex items-center justify-center">
          <a [href]="appleStoreLink" target="_blank">
            <img class="badge p-2" src="assets/images/apple@2x.png" />
          </a>
          <a [href]="googleStoreLink" target="_blank">
            <img class="badge p-2" src="assets/images/play@2x.png" />
          </a>
        </div>
        <div class="help">
          Need Help?
          <a href="mailto:telemetrysupport.telular@ametek.com">Contact Us</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Forgot Password -->
<ng-template id="forgotPasswordForm" #forgotPasswordForm>
  <mat-card style="min-width: 500px;">
    <mat-card-header>
      <h3>{{ 'ForgotPassword.PasswordReminder' | translate }}</h3>
    </mat-card-header>
    <div style="width: 100%; align-items: center">
      <mat-divider style="width: 90%"></mat-divider>
    </div>
    <mat-card-content>
      <form class="forgot-password-form" (keydown)="clearExistingFormErrors()">
        <div style="display: flex; flex-direction: column; margin: 10px; ">
          <app-tap-alert
            *ngIf="passwordExpired"
            type="warning"
            message="Login.PasswordExpiredResetRequired"
          ></app-tap-alert>
          <div class="text-danger" style="text-align: center">
            {{ forgotPwdFormError }}
          </div>
          <!-- User Name -->
          <fieldset
            class="form-field"
          >
            <div class="form-field-container">
              <label for="forgotPwdUserName">{{
                'ForgotPassword.UserName' | translate
              }}<span class="text-danger">*</span></label>
              <input
                matInput
                class="input-field"
                name="forgotPwdUserName"
                placeholder="{{ 'ForgotPassword.UserName' | translate }}"
                id="forgotPwdUserName"
                #forgotPwdUserName
                type="text"
              />
            </div>
            <div class="text-danger">{{ forgotPwdUserNameError }}</div>
          </fieldset>
          <!-- Email -->
          <fieldset
            class="form-field"
            style="display: flex; flex-direction: column"
          >
            <div class="form-field-container">
              <label for="forgotPwdEmail">{{
                'ForgotPassword.Email' | translate
              }}<span class="text-danger">*</span></label>
              <input
                matInput
                class="input-field"
                name="forgotPwdEmail"
                placeholder="{{ 'ForgotPassword.Email' | translate }}"
                id="forgotPwdEmail"
                #forgotPwdEmail
                type="email"
              />
            </div>
            <div class="text-danger">{{ forgotPwdEmailError }}</div>
          </fieldset>
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
          "
        >
          <ng-container
            *ngTemplateOutlet="
              submitButton;
              context: {
                label: 'ForgotPassword.RetrievePassword',
                isBusy: isResettingPassword,
                onClick: onResetPasswordClick.bind(this),
                data: {
                  userName: forgotPwdUserName?.value,
                  email: forgotPwdEmail?.value
                }
              }
            "
          ></ng-container>
          <a (click)="onBackClick($event)" style="cursor: pointer">
            {{ 'ForgotPassword.Back' | translate }}</a
          >
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template
  #submitButton
  let-label="label"
  let-isBusy="isBusy"
  let-isBusyLabel="isBusyLabel"
  let-data="data"
  let-onClick="onClick"
>
  <app-button-with-spinner
    [label]="label"
    [isBusy]="isBusy"
    [isBusyLabel]="isBusyLabel"
    [data]="data"
    (onClick)="onClick($event)"
  ></app-button-with-spinner>
</ng-template>
